import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('selectTimeZoneOption', function selectTimeZoneOption(timeZone) {
    var optionState = getRegionalOptions();
    optionState.selectedTimeZone = timeZone;
});
//# sourceMappingURL=selectTimeZoneOption.js.map